import {
	type AdminOperationId,
	type AdminRole,
	operationPolicies,
} from '@shared/api'

export const administrativeRoles: AdminRole[] = [
	'fitness-admin',
	'fitness-admin-viewer',
	'fitness-content-editor',
	'fitness-content-publisher',
	'fitness-media-manager',
]

export const hasAnyAdministrativeRole = (roles: readonly string[]) => {
	const assigned = new Set(roles)
	return administrativeRoles.some(role => assigned.has(role))
}

export const hasOperationAccess = (
	roles: readonly string[],
	operationId: AdminOperationId,
) => {
	const assigned = new Set(roles)
	return operationPolicies[operationId].roles.some(role => assigned.has(role))
}

export const routeOperations = {
	dashboard: 'getAdminSession',
	exercises: 'listExercises',
	programs: 'listPrograms',
	media: 'listMedia',
	archive: 'listExercises',
} as const satisfies Record<string, AdminOperationId>
